module.exports = __webpack_public_path__ + "img/Proliferation-CECA_10X_CC.1e8b2dfe.png";